module.exports = __webpack_public_path__ + "static/media/109-romania.9b96ec62.svg";